import { render, staticRenderFns } from "./GoveCounSolution.vue?vue&type=template&id=460f69dd&scoped=true"
import script from "./GoveCounSolution.vue?vue&type=script&lang=js"
export * from "./GoveCounSolution.vue?vue&type=script&lang=js"
import style0 from "./GoveCounSolution.vue?vue&type=style&index=0&id=460f69dd&prod&lang=scss&scoped=true"
import style1 from "./GoveCounSolution.vue?vue&type=style&index=1&id=460f69dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460f69dd",
  null
  
)

export default component.exports